export const Download = (that,url,params={}) => {
  return new Promise((resolve, reject) => {
    that.$json(url, params, {
      responseType: "blob"
    }).then(response => {
        var blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8"
        }); //type这里表示xlsx类型
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        const filename = response.headers["content-disposition"].split(
          "="
        )[1];
        const downloadName = decodeURIComponent(filename);
        downloadElement.download = downloadName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
        resolve(response);
      })
      .catch(e => {
        that.$message.error(e.message);
      });
  });
};



// WEBPACK FOOTER //
// ./src/common/download.js